<template >
  <div class="lives">
    <div class="banner">
      <div class="banner-warpper">
        <div class="container">
          <div class="banner-text">
            <h2>赛事现场</h2>
            <span class="subtitle"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="lives_main">
      <van-empty v-if="posts.length===0" description="暂无数据" style="padding-top:50px;" />
      <div class="container-water-fall case">
        <waterfall
          :col="col"
          :gutterWidth="20"
          :data="posts"
          @loadmore="loadmore1"
          :height="'72vh'"
          class="listbar"
          :lazyDistance="200"
        >
          <template>
            <div v-for="(item,index) in posts" :key="index" class="item">
              <img :src="`${item.image}?x-oss-process=style/thumb`" class="img-responsive" alt />
            </div>
          </template>
        </waterfall>
      </div>
      <!-- <p v-if="canloadMore" style="text-align:center;padding:10px;">
        <a href="javascript:;" class="next" style="text-decoration: underline;" @click="page++">加载更多</a>
      </p>-->
    </div>
  </div>
</template>
<script >
import _ from "underscore";
export default {
  data() {
    return {
      canloadMore: false,
      posts: [],
      page: 1,
      col: 4,
    };
  },
  watch: {
    page() {
      this.getdata();
    },
  },
  methods: {
    loadmore1() {
      console.log("loadmore");
      if (this.canloadMore) this.page++;
    },
    getdata() {
      this.$api
        .post("/wapi", {
          method: "ssy-app/live/getList",
          data: {
            page: this.page,
            limit: 24,
          },
        })
        .then((res) => {
          if (res.code !== 0) return;
          this.canloadMore = res.data.canloadMore;
          if (this.posts.length === 0) {
            this.posts = res.data.data;
          } else {
            this.posts.push(...res.data.data);
          }
        })
        .catch((err) => {});
    },
  },
  mounted() {
    this.getdata();
  },
};
</script>
<style>
.item {
  padding: 5px 0;
}
</style>